import styled from "styled-components";

export const Container = styled.div`
    height: 100%;

    .logButton{
        position: fixed;
        bottom: 0;
        background: #FFF;
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 5px;
        svg{
            min-height: 3rem;
            font-size: 3rem;
            color: var(--colorButton);
            cursor: pointer;
            margin-bottom: 5px;
        }
    }
`
